import { isValidElementType } from 'react-is';

var validateComponentProp = function validateComponentProp(props, propName, componentName) {
  if (!isValidElementType(props[propName])) {
    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`.');
  }

  return null;
};

export default validateComponentProp;


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/util/validateComponentProp.js
// module id = oM3U
// module chunks = 1